import { cleanCookies } from "../utils/Utils";

export const isAuthenticatedNode = () =>
  localStorage.getItem("oauth_token") !== null;

export const getNodeToken = () => {
  return localStorage.getItem("oauth_token") || "";
};

export const getRefreshToken = () => {
  return localStorage.getItem("refresh_token") || "";
};

export const setUserNode = (json) => {
  localStorage.setItem("USER_NODE", JSON.stringify(json));
};

export const getUserNode = () =>
  localStorage.getItem("USER_NODE") != null
    ? JSON.parse(localStorage.getItem("USER_NODE"))
    : {
        email: null,
        foto: null,
        id: null,
        nome: null,
        premium: null,
        admin: null,
        gestorEmpresa: null,
        aluno_empresa: null,
        alunoEmpresa: null,
        empresa: null,
      };

export const logoutNode = () => {
  localStorage.removeItem("USER_NODE");
  localStorage.removeItem("oauth_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("USER_KEY");

  // auth antiga
  localStorage.removeItem("USER");
  localStorage.removeItem("Token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("NOTIFY");
  localStorage.removeItem("_IS_ADM");
  localStorage.removeItem("_IS_EMP");

  cleanCookies().then(() => {
    setTimeout(() => {
      if (window.location.pathname !== "/") {
        window.location.href = '/login';
      }
    }, 500);
  });

  window.location.href = "/login";
};
